import React, { useEffect, useRef } from 'react';

export default function DesignGalleryVideo({ src, alt, loopStart, loopEnd, autoPlay = true }) {
  const ref = useRef(null);
  const hasSegmentLoop = Number.isFinite(loopStart) && Number.isFinite(loopEnd);

  useEffect(() => {
    const video = ref.current;
    if (!video || !hasSegmentLoop) return;

    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    if (reduced) {
      video.pause();
      return;
    }

    const onLoaded = () => {
      video.currentTime = loopStart;
      if (autoPlay) {
        video.play().catch(() => {});
      }
    };

    const onTimeUpdate = () => {
      if (video.currentTime >= loopEnd) {
        video.currentTime = loopStart;
        if (autoPlay) {
          video.play().catch(() => {});
        }
      }
    };

    if (video.readyState >= 1) {
      onLoaded();
    }
    video.addEventListener('loadedmetadata', onLoaded);
    video.addEventListener('timeupdate', onTimeUpdate);
    return () => {
      video.removeEventListener('loadedmetadata', onLoaded);
      video.removeEventListener('timeupdate', onTimeUpdate);
    };
  }, [src, loopStart, loopEnd, autoPlay, hasSegmentLoop]);

  const reducedMotion =
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

  return (
    <video
      ref={ref}
      className="design-gallery__video"
      src={src}
      muted
      playsInline
      loop={!hasSegmentLoop}
      autoPlay={!reducedMotion && autoPlay}
      controls={reducedMotion}
      preload="metadata"
      aria-label={alt}
    />
  );
}
